import Vue from 'vue';
import vueCustomElement from 'vue-custom-element';
import salComponents from '@/components/sal-components';

Vue.use(vueCustomElement);
Vue.config.productionTip = false;

Vue.customElement('sal-components', salComponents);
